import { put, apply } from 'redux-saga/effects';

import ironLegacyClient from '@app/data/ironLegacyClient';
import { productGraphSuccess, productGraphFail } from './actions';

export function* onProductGraphRequest({ payload: { id } }) {
  try {
    const result = yield apply(
      ironLegacyClient,
      ironLegacyClient.getProductGraph,
      [id],
    );

    yield put(productGraphSuccess({ graph: result.body.data, id }));
  } catch (err) {
    // @ts-expect-error
    yield put(productGraphFail({ error: err.response }));
  }
}
